import config from './_config'
import { Memberships } from './types'
import { useQuery } from '../../internal'
import { API } from '../../internal/types'
import useIsAuthenticated from '../../store/useIsAuthenticated'

const useGetMembership = (id: number | 'me', options?: API.QueryOptions) => {
  const isAuthenticated = useIsAuthenticated()

  const query = useQuery<typeof id>(id, {
    ...options,
    enabled: [...(options?.enabled || []), !!isAuthenticated, !!id]
  })

  const response = query<Memberships.Membership>({
    cacheKey: config.cacheKeys.byId(id),
    endpoint: config.endpoints.membershipId(id)
  })

  return response
}

export default useGetMembership
